<script lang="ts" setup>
import { PublicDeliverySeller } from '@gql/PublicDeliverySeller'

const t2 = useT2({
  Loading: 'Kraunama',
  Shipping: 'Pristatymas',
  Locker: 'Paštomatas',
  'Shipping and Delivery': 'Pristatymas ir pristatymo sąlygos',
  Courier: 'Kurjeris',
  'Shipping rates are calculated in real-time by the carrier': 'Pristatymo kainos apskaičiuojamos realiu laiku pagal kurjerio tarifus',
  'Free delivery': 'Nemokamas pristatymas',
  'Delivery cost will be determined after checkout': 'Pristatymo kaina bus apskaičiuota po užsakymo pateikimo',
})

const { seller, sellerId: sellerIdV } = useSeller('server')
const auth = useAuth()
const [buyerCountry, buyerCountrySet] = useValueSynced2((): gen.InputBuyerAddressCountry => {
  const def = auth.value.addressDefault
  return { iso2: def.iso2 }
})

const input = computed((): gen.InputPublicDeliverySeller | None => {
  const sellerId = sellerIdV.value
  const country = buyerCountry.value
  if (!sellerId || !country) return
  return { sellerId, country }
})

const { ui: deliveries, loading } = useApolloWrap2<gen.PublicDeliverySellerQuery, gen.PublicDeliverySellerQueryVariables>(PublicDeliverySeller)({
  vars() {
    const inp = input.value
    return inp ? { input: inp } : undefined
  },
  ui: (i) => {
    const res = i?.publicDeliverySeller
    const asd: { name: stringI18n; items: NN<typeof res>['shipping'] }[] = []
    if (res?.shipping?.length) asd.push({ name: t2('Shipping'), items: res?.shipping })
    if (res?.locker?.length) asd.push({ name: t2('Locker'), items: res?.locker })
    if (res?.location?.length) asd.push({ name: t2('Location'), items: res?.location })
    return asd
  },
})

useHead({
  title: t2('Shipping & Delivery'),
})
</script>

<template>
  <AppMenu :title="t2('Shipping and Delivery')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.shipping?._id" />
    </template>

    <div class="_w70ch m_pl04 m_pr04">
      <InputCountry :in="buyerCountry" :out="(i) => buyerCountrySet(i)" novalidate />
    </div>

    <template v-if="loading">
      <h2 class="_pb2 _pt4 _pl1">{{ t2('Loading') }}</h2>
      <UiLoadingBox :repeat="3" height="_h80" mb="_mb04" />
    </template>

    <template v-else>
      <UiEmpty :empty="!deliveries.length" />
      <template v-for="itemTop in deliveries" :key="itemTop.name">
        <h2 class="_pb2 _pt4 _pl1">{{ itemTop.name }}</h2>

        <InfoBoxes :items="itemTop.items" :ui="(i) => ({ key: i.id, title: i.title, hasContent: true })">
          <template #txt="{ item }">
            <div class="_row _ctrY _hm40">
              <h3 v-if="item.title" class="_inline">{{ item.title }}</h3>
            </div>
            <UiLine :label="t2('Courier')" :value="item.courier" />
          </template>

          <template #default="{ item }">
            <div v-if="item?.pricingType === 'Fedex'" class="_txt">{{ t2('Shipping rates are calculated in real-time by the carrier') }}</div>
            <div v-else-if="item?.pricingType === 'Free'" class="_txt">{{ t2('Free delivery') }}</div>
            <div v-else-if="item?.pricingType === 'Quote'" class="_txt">{{ t2('Delivery cost will be determined after checkout') }}</div>
            <LazyInfoPageDeliveryOne v-else-if="input && item?.pricingType === 'Table'" :deliveryid="item.id" :input />
          </template>
        </InfoBoxes>
      </template>
    </template>
  </AppMenu>
</template>
